"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUrlParams = exports.setServices = exports.fetch = exports.default = exports.FetchAPI = void 0;

var _es6Promise = _interopRequireDefault(require("es6-promise"));

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

var _getFetchConfig = require("./getFetchConfig");

var _fetchAPI = _interopRequireDefault(require("./fetchAPI"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_es6Promise.default.polyfill();

var fetchAPI = new _fetchAPI.default();
var FetchAPI = _fetchAPI.default;
exports.FetchAPI = FetchAPI;
var fetch = _isomorphicFetch.default;
exports.fetch = fetch;
var setServices = _getFetchConfig.setService;
exports.setServices = setServices;
var setUrlParams = _getFetchConfig.setUrlParam;
exports.setUrlParams = setUrlParams;
var _default = fetchAPI;
exports.default = _default;